import React, { useEffect, useState } from "react";
import blogFetch from "../../axios/config";
import Button from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
import {
  IGroup,
  IUserGroupsProps,
  IUserGroups,
} from "./UserGroupsInterfaces";

export default function UserGroups({
  user,
  groups,
  setGroups
}: IUserGroupsProps) {
  const [toggleRender, setToggleRender] = useState<boolean>(false);
  const [localGroups, setLocalGroups] = useState<IGroup[]>(groups);

  useEffect(() => {
    const fetchData = async () => {
      let Grupos = await getUserGroups();
      await getUserGroupsById(Grupos);
    };

    fetchData();
  }, []);

  const getUserGroups = async () => {
    try {
      let response = await blogFetch.get(`/group`);
      let data = response.data;
      setLocalGroups(data); 
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const getUserGroupsById = async (gruposProps: IGroup[]) => {
    try {
      let response = await blogFetch.get(`/UsersGroups/${user.user_Id}`);
      let data: IUserGroups[] = response.data;
      let list: any[] = [];
      for (let i = 0; i < data.length; i++) {
        list.push(data[i].group.group_Id);
      }
      const newCheckList = gruposProps.map((item) => {
        const container = item;
        if (list.includes(item.group_Id)) {
          container["checked"] = true;
        } else {
          container["checked"] = false;
        }

        return container;
      });

      setLocalGroups(newCheckList); 
      setToggleRender(!toggleRender);
    } catch (error) {
      console.error(error);
    }
  };

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    let newCheckList = localGroups;
    for (let i = 0; i < newCheckList.length; i++) {
      if (newCheckList[i].group_Id.toString() === event.target.value) {
        newCheckList[i].checked = event.target.checked;
        break;
      }
    }
    setGroups(newCheckList); 
    setLocalGroups(newCheckList); 
    setToggleRender(!toggleRender);
  };

  const checkBox = () => {
    return (
      <div>
        <div>
        </div>
        {!!localGroups &&
          localGroups.map((group) => (
            <FormControlLabel
              key={group.group_Id}
              style={{ width: 150 }}
              control={
                <Checkbox
                  checked={group.checked}
                  onChange={handleCheck}
                  name={group.group_description}
                  value={group.group_Id.toString()}
                />
              }
              label={group.group_description}
            />
          ))}
      </div>
    );
  };

  return (
    <div>
      <h3 style={{ textAlign: "center" }}>Grupos</h3>
      {toggleRender ? checkBox() : <section>{checkBox()}</section>}
    </div>
  );
}
